var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeaturesEight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.65,
    y: 0.65,
    width: 30.7,
    height: 30.7,
    rx: 4.35,
    stroke: "#565656",
    strokeOpacity: 0.2,
    strokeWidth: 1.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.42385 8.8071C6.19294 8.95592 6.00007 9.17281 6.00007 9.48313V22.0001C6.00007 22.0001 5.95019 24.5832 8.42936 24.5832H24.2123C24.7132 24.5832 25.4438 24.4426 25.7178 24.1286C25.8743 23.9489 26 23.7197 26 23.4462C26 23.1681 25.8702 22.913 25.7105 22.7043C25.4383 22.3486 24.7132 22.1522 24.2123 22.1508L10.218 22.1067C9.71661 22.1049 8.96066 22.1702 8.67303 21.932C8.53513 21.8182 8.42936 21.6307 8.42936 21.3258V19.2894C8.42936 18.7885 8.81684 18.2599 9.29509 18.1102L12.4566 17.117C12.9349 16.9668 13.6422 17.0962 14.0365 17.4056L17.6432 20.2354C18.0375 20.5448 18.6528 20.5172 19.0176 20.1733L25.1955 14.3538C25.5603 14.0099 25.8629 13.3252 25.8711 12.8243L25.9047 10.8478C25.9132 10.3469 25.6265 10.2217 25.2649 10.5688L19.092 16.4868C18.7303 16.8339 18.1114 16.872 17.7099 16.5721L14.1604 13.9205C13.7588 13.6206 13.0502 13.5122 12.5769 13.6778L9.31228 14.8239C8.83945 14.99 8.4538 14.7183 8.45205 14.2169L8.43386 10.2871C8.43161 9.7862 8.26777 9.04985 7.92475 8.78299C7.58172 8.51579 6.81134 8.5575 6.42385 8.8071Z",
    fill: "#494949"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturesEight);
export default __webpack_public_path__ + "static/media/features-eight.76b11b7c.svg";
export { ForwardRef as ReactComponent };